'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var appTypes = require('../../types/appTypes.js');
var Alert = require('./Alert.jsx');
var _ = require('underscore');
var PopupHelper = require('../../interactive/PopupHelper');
var util = require('../../helper/util');

/*
 @Author : mengxiaojiang
 @CreateDate : 2016-6-1
 @Descript : 弹出窗口组件
 */
var AlertWindow = React.createClass({

  render: function () {
    var bgComp = this.props.items[0];
    var contentComp = this.props.items[1];
    var bg = util.Color.setOpacity(bgComp.color,0.4);
    var dom = <div
      key={this.props.controlID}
      id={this.props.controlID}
      className='component component-AlertWindow popup-control'
      style={{
          visibility : this.props.popup?'visible': 'hidden',
          zIndex : this.props.zOrder
        }}>
      <div id={this.props.controlID + '-background'}
           ref="background"
           className="background"
           style={{
             width : this.props.measureWidth || 0,
             height : this.props.measureHeight || 0,
             backgroundColor : this.props.isShowBackground ? bg : 0,
             pointerEvents : this.props.closeByClickMode === appTypes.PopupPanelClosePolicy.NONE ? 'auto' : 'none'
           }}></div>
      <div id={this.props.controlID + '-content'}
           className="content"
           ref="content"
           style={{
             left : contentComp.x,
             top : contentComp.y,
             width : contentComp.w + 2,
             height : contentComp.h + 2,
             opacity : this.props.popup?1:0
           }}>
        {
          this.props.children
        }
      </div>
    </div>;
    return (dom);
  },

  componentDidMount: function () {
    this.doInitContent();
    this.doPopup();
    if(this.props.onOpened) {
      this.props.onOpened(this.props);
    }
  },

  componentDidUpdate : function(){
    this.doInitContent();
    this.doPopup();
  },
  doInitContent : function(){
    var alertDom = ReactDOM.findDOMNode(this.refs.content).children[0];
    $(alertDom).css({left: 0, top: 0, opacity: 1});
  },
  doPopup : function(){
    PopupHelper.registerPopup(this);
    if(this.open){
      this.open();
    }

    var dom = $(ReactDOM.findDOMNode(this));
    var content = $(ReactDOM.findDOMNode(this.refs.content));
    var background = $(ReactDOM.findDOMNode(this.refs.background));
    if (this.props.isPopupClosing && this.props.closePopup) {
      this.props.closePopup(dom, this.props, content, background);
    }
  }

});

module.exports = AlertWindow;



// WEBPACK FOOTER //
// ./src/views/Components/AlertWindow.jsx